// Page: entry-form  (flow start — "Enter Zip" search + broker attribution)
//
// Ported from the inline <script> in
//   Enrollment_modules/entry/form.module/module.html (lines 68–1175).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes
// (same family as the pilot, see docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors scoped to this module's HubSpot render-time wrapper
//      `#Page_0_Enter_Zip_widget` are now scoped to `root`. Whole-widget toggles
//      (`getElementById('Page_0_Enter_Zip_widget')`) and cross-widget wrappers
//      (`#Page_0_Project_Found_widget`, `#Page_0_Project_not_Found_widget`,
//      `#Page_0_Illinois_Project_Found_widget`, `#addUtiDisName`, `#utProvider`)
//      stay document-scoped, as in the original.
//   2. `_hcms/api/*` fetches and the /account redirect are ROOT-RELATIVE
//      (apiUrl / "/account") instead of hardcoding https://enrollment.nautilussolar.com.
//   3. HubDB reads go through core/hubdb (`hubdbRowsUrl` / `hubdbRowUrl`) using
//      window.__ENV__ table ids + fixed dataPortalId.
//   4. findSignSolar's single-row read used a hardcoded table id (15223639 ==
//      utilityFarm) and `portalId="{{ hub_id }}"` (the rendering portal). It now
//      reads `hubdbRowUrl("utilityFarm", id)` — table id from __ENV__ and the
//      fixed centralized dataPortalId — matching every other HubDB read here and
//      fixing a latent sandbox 404 (sandbox HubDB tables don't exist).
//   5. localStorage goes through core/storage (rawGet/rawSet — the many broker_/
//      Farm* keys aren't in the typed StorageKey union yet; tightening is deferred).
//   6. Inline onclick/oninput handlers (findSolar/findSignSolar/validateNumericInput)
//      are bound in init instead of via HTML attributes (no inline logic).
//   7. The orphaned axios <script src> was dropped from module.html — the inline
//      script never called axios (matches Wave 1's dead-<script src> cleanup).
//
// Dynamic ES5 patterns (HubDB row shapes, vars reassigned across types) are typed
// `any` to keep the port mechanical.
//
// The original inline script called a Google-Maps `initMap()` global here after a
// farm was located; that map feature has been retired (it never rendered
// post-migration — a swallowed ReferenceError), so the call is removed.

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl, hubdbRowUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/entry/entry-form.ts","init",[root,_config],["root","_config"]);
  storage.clear()

  // ─── log in button ──────────────────────────────────────────────────────────
  const cpse = root.querySelector("#cpse")
  cpse?.addEventListener("click", () => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[],[]);
    window.location.href = "/account"
  })

  // ─── validate input to just type number value ─────────────────────────────────
  function validateNumericInput(input: HTMLInputElement) {
__ea_trace("modules/entry/entry-form.ts","validateNumericInput",[input],["input"]);
    input.value = input.value.replace(/[^0-9]/g, "")
  }

  // ─── referral code + user id bootstrapping ────────────────────────────────────
  // implicit globals in the original (bare assigns, no `var`) — declared here so
  // strict-mode ESM doesn't throw ReferenceError.
  let repid: any
  let referralUrl: any
  let first_visited_url: any

  function generateUserId() {
__ea_trace("modules/entry/entry-form.ts","generateUserId",[],[]);
    return `user_${Math.random().toString(36).substr(2, 9)}`
  }
  function getQueryParam(name: string) {
__ea_trace("modules/entry/entry-form.ts","getQueryParam",[name],["name"]);
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }
  function getUserId() {
__ea_trace("modules/entry/entry-form.ts","getUserId",[],[]);
    let userId = storage.rawGet("userId")
    if (userId == null) {
      userId = generateUserId()
      storage.rawSet("userId", userId)
    }
    const attcode = getQueryParam("attcode")
    repid = getQueryParam("repid")
    const isImpact = getQueryParam("impacttest")
    const imRef = getQueryParam("im_ref")

    if ((isImpact as any) === 1 || isImpact === "1") {
      storage.rawSet("isImpact", "Yes")
      storage.rawSet("clickId", imRef as string)
    } else {
      storage.rawSet("isImpact", "No")
      storage.rawSet("clickId", imRef as string)
    }
    referralUrl = window.location.href
    first_visited_url = window.location.href
    if (attcode != null || repid != null) {
      if (attcode !== "" || repid !== "") {
        storage.rawSet("attcode", attcode as string)
        storage.rawSet("repid", repid as string)
        storage.rawSet("referralUrl", referralUrl)
      }
    }
    const attcodeNew = storage.rawGet("attcode")
    const repidNew = storage.rawGet("repid")
    if (attcodeNew != null || repidNew != null) {
      if (attcodeNew !== "" || repidNew !== "") {
        ;(document.querySelector(".refCodeWrapper") as HTMLElement).style.display = "none"
      } else {
        ;(document.querySelector(".refCodeWrapper") as HTMLElement).style.display = "block"
      }
    } else {
      ;(document.querySelector(".refCodeWrapper") as HTMLElement).style.display = "block"
    }
    return userId
  }
  getUserId()

  // ─── hide zip code error on keyup ─────────────────────────────────────────────
  const zipCodeInput = root.querySelector("#zipCode") as HTMLInputElement
  const resultMessageDiv = root.querySelector("#resultMessage") as HTMLElement
  zipCodeInput.addEventListener("keyup", () => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[],[]);
    resultMessageDiv.style.display = "none"
  })

  // ─── loader ───────────────────────────────────────────────────────────────────
  function enterZipOpenLoader() {
__ea_trace("modules/entry/entry-form.ts","enterZipOpenLoader",[],[]);
    const loader = document.getElementById("enterZipLoader") as HTMLElement
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    ;(document.getElementById("EZloaderOverlay") as HTMLElement).style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = true
    })
  }
  function enterZipcloseLoader() {
__ea_trace("modules/entry/entry-form.ts","enterZipcloseLoader",[],[]);
    const loader = document.getElementById("enterZipLoader") as HTMLElement
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    ;(document.getElementById("EZloaderOverlay") as HTMLElement).style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = false
    })
  }

  let _dealOwner: any = 0

  // ─── find solar ─────────────────────────────────────────────────────────────
  async function findSolar() {
__ea_trace("modules/entry/entry-form.ts","findSolar",[],[]);
    let localattcode = storage.rawGet("attcode")
    const attRepId = storage.rawGet("repid")
    /* manual process */ if (
      (localattcode == null || localattcode === "null") &&
      (attRepId == null || attRepId === "null")
    ) {
      let attcode = (root.querySelector("#gsicode") as HTMLInputElement).value.trim()
      if (!(attcode === "")) {
        attcode = attcode.toUpperCase()
        const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
          attribution_code: attcode,
          default_broker_contact: 1,
        })
        fetch(hubDBEndpoint, { method: "GET" })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              let isFirstIteration = true
              rows.forEach((element: any) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[element],["element"]);
                if (rows.length === 1) {
                  if (isFirstIteration) {
                    isFirstIteration = false
                    repid = element.values["10"]
                    referralUrl = element.values["5"]
                    _dealOwner = element.values["11"]
                    storage.rawSet("attcode", attcode)
                    storage.rawSet("repid", repid)
                    storage.rawSet("referralUrl", referralUrl)
                    storage.rawSet("dealOwner", _dealOwner)
                    const brokerRepPhoneNo = element.values["6"]
                    const brokerRepEmail = element.values["7"]
                    const brokerRepTitle = element.values["9"]
                    const brokerRepName = element.values["4"]
                    const brokerCompany = element.values["2"]
                    if (element.values["8"] !== undefined) {
                      const brokerRepImage = element.values["8"].url
                      storage.rawSet("brokerRepImage", brokerRepImage)
                    }
                    if (element.values["13"] !== undefined) {
                      const brokerMeetingUrl = element.values["13"].url
                      storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                    }
                    storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                    storage.rawSet("brokerRepEmail", brokerRepEmail)
                    storage.rawSet("brokerRepTitle", brokerRepTitle)
                    if (brokerRepName !== undefined) {
                      storage.rawSet("brokerRepName", brokerRepName)
                    }
                    storage.rawSet("brokerCompany", brokerCompany)
                    storage.rawSet("sidebarBrokerDisplay", "Yes")
                  }
                } else {
                  if (element.values["12"] === 1) {
                    if (isFirstIteration) {
                      isFirstIteration = false
                      repid = element.values["10"]
                      referralUrl = element.values["5"]
                      _dealOwner = element.values["11"]
                      storage.rawSet("attcode", attcode)
                      storage.rawSet("repid", repid)
                      storage.rawSet("referralUrl", referralUrl)
                      storage.rawSet("dealOwner", _dealOwner)
                      const brokerRepPhoneNo = element.values["6"]
                      const brokerRepEmail = element.values["7"]
                      const brokerRepTitle = element.values["9"]
                      const brokerRepName = element.values["4"]
                      const brokerCompany = element.values["2"]
                      if (element.values["8"] !== undefined) {
                        const brokerRepImage = element.values["8"].url
                        storage.rawSet("brokerRepImage", brokerRepImage)
                      }
                      if (element.values["13"] !== undefined) {
                        const brokerMeetingUrl = element.values["13"].url
                        storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                      }
                      storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                      storage.rawSet("brokerRepEmail", brokerRepEmail)
                      storage.rawSet("brokerRepTitle", brokerRepTitle)
                      if (brokerRepName !== undefined) {
                        storage.rawSet("brokerRepName", brokerRepName)
                      }
                      storage.rawSet("brokerCompany", brokerCompany)
                      storage.rawSet("sidebarBrokerDisplay", "Yes")
                    }
                  }
                }
              })
            } else {
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      } else {
        storage.rawSet("sidebarBrokerDisplay", "No")
      }
    } else if (localattcode !== "null" && localattcode != null && localattcode !== "" && localattcode !== undefined) {
      localattcode = localattcode.toUpperCase()
      if (attRepId === "" || attRepId === " " || attRepId === undefined || attRepId == null) {
        const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
          attribution_code: localattcode,
          default_broker_contact: 1,
        })
        fetch(hubDBEndpoint, { method: "GET" })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              for (let i = 0; i < rows.length; i++) {
                const element = rows[i]
                _dealOwner = element.values["11"]
                repid = element.values["10"]
                storage.rawSet("dealOwner", _dealOwner)
                const brokerRepPhoneNo = element.values["6"]
                const brokerRepEmail = element.values["7"]
                const brokerRepTitle = element.values["9"]
                const brokerRepName = element.values["4"]
                const brokerCompany = element.values["2"]
                if (element.values["8"] !== undefined) {
                  const brokerRepImage = element.values["8"].url
                  storage.rawSet("brokerRepImage", brokerRepImage)
                }
                if (element.values["13"] !== undefined) {
                  const brokerMeetingUrl = element.values["13"].url
                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                }
                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                storage.rawSet("brokerRepEmail", brokerRepEmail)
                storage.rawSet("brokerRepTitle", brokerRepTitle)
                if (brokerRepName !== undefined) {
                  storage.rawSet("brokerRepName", brokerRepName)
                }
                storage.rawSet("brokerCompany", brokerCompany)
                storage.rawSet("sidebarBrokerDisplay", "Yes")
                storage.rawSet("repid", repid)
                break
              }
            } else {
              storage.rawRemove("attcode")
              storage.rawRemove("repid")
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      } else if (
        localattcode !== "null" &&
        localattcode != null &&
        localattcode !== "" &&
        localattcode !== undefined &&
        attRepId !== "null" &&
        attRepId != null &&
        attRepId !== "" &&
        attRepId !== undefined
      ) {
        const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
          attribution_code: localattcode,
          attribution_rep_id: attRepId,
        })
        fetch(hubDBEndpoint, { method: "GET" })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              for (let i = 0; i < rows.length; i++) {
                const element = rows[i]
                _dealOwner = element.values["11"]
                storage.rawSet("dealOwner", _dealOwner)
                const brokerRepPhoneNo = element.values["6"]
                const brokerRepEmail = element.values["7"]
                const brokerRepTitle = element.values["9"]
                const brokerRepName = element.values["4"]
                const brokerCompany = element.values["2"]
                if (element.values["8"] !== undefined) {
                  const brokerRepImage = element.values["8"].url
                  storage.rawSet("brokerRepImage", brokerRepImage)
                }
                if (element.values["13"] !== undefined) {
                  const brokerMeetingUrl = element.values["13"].url
                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                }
                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                storage.rawSet("brokerRepEmail", brokerRepEmail)
                storage.rawSet("brokerRepTitle", brokerRepTitle)
                if (brokerRepName !== undefined) {
                  storage.rawSet("brokerRepName", brokerRepName)
                }
                storage.rawSet("brokerCompany", brokerCompany)
                storage.rawSet("sidebarBrokerDisplay", "Yes")
                break
              }
            } else {
              storage.rawRemove("attcode")
              storage.rawRemove("repid")
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      } else {
        const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
          attribution_rep_id: attRepId,
        })
        fetch(hubDBEndpoint, { method: "GET" })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              for (let i = 0; i < rows.length; i++) {
                const elementt = rows[i]
                if (elementt.values["5"].includes(attRepId)) {
                  _dealOwner = elementt.values["11"]
                  repid = elementt.values["10"]
                  localattcode = elementt.values["3"]
                  storage.rawSet("dealOwner", _dealOwner)
                  const brokerRepPhoneNo = elementt.values["6"]
                  const brokerRepEmail = elementt.values["7"]
                  const brokerRepTitle = elementt.values["9"]
                  const brokerRepName = elementt.values["4"]
                  const brokerCompany = elementt.values["2"]
                  if (elementt.values["8"] !== undefined) {
                    const brokerRepImage = elementt.values["8"].url
                    storage.rawSet("brokerRepImage", brokerRepImage)
                  }
                  if (elementt.values["13"] !== undefined) {
                    const brokerMeetingUrl = elementt.values["13"].url
                    storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                  }
                  storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                  storage.rawSet("brokerRepEmail", brokerRepEmail)
                  storage.rawSet("brokerRepTitle", brokerRepTitle)
                  if (brokerRepName !== undefined) {
                    storage.rawSet("brokerRepName", brokerRepName)
                  }
                  storage.rawSet("brokerCompany", brokerCompany)
                  storage.rawSet("sidebarBrokerDisplay", "Yes")
                  storage.rawSet("repid", repid)
                  storage.rawSet("attcode", localattcode as string)
                  break
                } else {
                  if (i === rows.length - 1) {
                    storage.rawRemove("attcode")
                    storage.rawRemove("repid")
                    storage.rawSet("sidebarBrokerDisplay", "No")
                  }
                }
              }
            } else {
              storage.rawRemove("attcode")
              storage.rawRemove("repid")
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      }
    } else if (attRepId != null && attRepId !== "null" && attRepId !== "" && attRepId !== undefined) {
      const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
        attribution_rep_id: attRepId,
      })
      fetch(hubDBEndpoint, { method: "GET" })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
          const rows = data.objects
          if (rows.length >= 1) {
            for (let i = 0; i < rows.length; i++) {
              const elementt = rows[i]
              if (elementt.values["5"].includes(attRepId)) {
                _dealOwner = elementt.values["11"]
                repid = elementt.values["10"]
                localattcode = elementt.values["3"]
                storage.rawSet("dealOwner", _dealOwner)
                const brokerRepPhoneNo = elementt.values["6"]
                const brokerRepEmail = elementt.values["7"]
                const brokerRepTitle = elementt.values["9"]
                const brokerRepName = elementt.values["4"]
                const brokerCompany = elementt.values["2"]
                if (elementt.values["8"] !== undefined) {
                  const brokerRepImage = elementt.values["8"].url
                  storage.rawSet("brokerRepImage", brokerRepImage)
                }
                if (elementt.values["13"] !== undefined) {
                  const brokerMeetingUrl = elementt.values["13"].url
                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                }
                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                storage.rawSet("brokerRepEmail", brokerRepEmail)
                storage.rawSet("brokerRepTitle", brokerRepTitle)
                if (brokerRepName !== undefined) {
                  storage.rawSet("brokerRepName", brokerRepName)
                }
                storage.rawSet("brokerCompany", brokerCompany)
                storage.rawSet("sidebarBrokerDisplay", "Yes")
                storage.rawSet("repid", repid)
                storage.rawSet("attcode", localattcode as string)
                break
              } else {
                if (i === rows.length - 1) {
                  storage.rawRemove("attcode")
                  storage.rawRemove("repid")
                  storage.rawSet("sidebarBrokerDisplay", "No")
                }
              }
            }
          } else {
            storage.rawRemove("attcode")
            storage.rawRemove("repid")
            storage.rawSet("sidebarBrokerDisplay", "No")
          }
        })
    }

    /* list items getting removed on page load - multiple utility name/zip code */
    const utilitynameCardss = root.querySelector("#retailUtilities-main") as HTMLElement
    utilitynameCardss.style.display = "none"
    const listt = root.querySelector("#retailUtilities") as HTMLElement
    listt.innerHTML = ""

    const enteredZip = (root.querySelector("#zipCode") as HTMLInputElement).value.trim()
    if (enteredZip !== "") {
      ;(root.querySelector("#resultMessage") as HTMLElement).style.display = "none"
      checkZipCodeInHubDB(enteredZip)
    } else {
      ;(root.querySelector("#resultMessage") as HTMLElement).style.display = "block"
      ;(root.querySelector("#resultMessage") as HTMLElement).innerText = "Please enter a zip code."
    }

    function checkZipCodeInHubDB(zipCode: string) {
__ea_trace("modules/entry/entry-form.ts","checkZipCodeInHubDB",[zipCode],["zipCode"]);
      enterZipOpenLoader()
      const hubDBEndpoint = hubdbRowsUrl("communitySolar", { zip_code: zipCode })
      fetch(hubDBEndpoint, { method: "GET" })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
          const rows = data.objects
          let zipcount = 0
          if (rows.length >= 1) {
            for (let i = 0; i <= rows.length; i++) {
              const currentObject = rows[i]
              const _zipColId = 1
              const RetailUtiColId = 4
              const utilityDisplayName = currentObject.values[RetailUtiColId]
              const utility_id = currentObject.values[3]
              const county = currentObject.values[5]
              const newItem = document.createElement("li")
              newItem.id = utility_id
              if (utilityDisplayName !== undefined) {
                newItem.textContent = utilityDisplayName
              } else {
                newItem.textContent = utility_id
              }
              const utilitynameCards = root.querySelector("#retailUtilities-main") as HTMLElement
              const list = root.querySelector("#retailUtilities") as HTMLElement
              list.appendChild(newItem)
              zipcount = ++zipcount
              if (zipcount > 1) {
                enterZipcloseLoader()
                utilitynameCards.style.display = "block"
                /* ------- Add active class click on utility name li ---------- */
                ;(root.querySelector("#retailUtilities") as HTMLElement).addEventListener("click", (event) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[event],["event"]);
                  if ((event.target as HTMLElement).tagName === "LI") {
                    const utilitynotselected = root.querySelector("#iflinotclick-msg") as HTMLElement
                    utilitynotselected.style.display = "none"
                    root.querySelectorAll("#retailUtilities li").forEach((item) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[item],["item"]);
                      item.classList.remove("active")
                    })
                    ;(event.target as HTMLElement).classList.add("active")
                  }
                })
                ;(root.querySelector("#multiZipButton") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[],[]);
                  const activeLiId = root.querySelector("#retailUtilities li.active") as HTMLElement
                  if (activeLiId) {
                    const activeLiIdd = activeLiId.id
                    const UtilityDisplayNameForSignUp = activeLiId.textContent as string
                    const utilityNameAppend = document.querySelector(
                      "#Page_0_Project_Found_widget #utilityNameAppend",
                    ) as HTMLElement
                    utilityNameAppend.textContent = UtilityDisplayNameForSignUp
                    storage.rawSet("utility_Name", UtilityDisplayNameForSignUp)
                    storage.rawSet("utility_id", activeLiIdd)
                    storage.rawSet("zip_code", zipCode)
                    storage.rawSet("county", county)
                    checkUtilityIdInFarmTable(activeLiIdd)
                  } else {
                    const utilitynotselected = root.querySelector("#iflinotclick-msg") as HTMLElement
                    utilitynotselected.style.display = "block"
                  }
                })
                /* ------- Add active class click on utility name li ---------- */
              } else {
                if (i === rows.length - 1) {
                  const utilityNameAppend = document.querySelector(
                    "#Page_0_Project_Found_widget #utilityNameAppend",
                  ) as HTMLElement
                  utilityNameAppend.textContent = utilityDisplayName
                  storage.rawSet("utility_Name", utilityDisplayName)
                  storage.rawSet("utility_id", utility_id)
                  storage.rawSet("zip_code", zipCode)
                  storage.rawSet("county", county)
                  enterZipcloseLoader()
                  checkUtilityIdInFarmTable(utility_id)
                }
              }
            }
          } else {
            enterZipcloseLoader()
            const ez = document.getElementById("Page_0_Enter_Zip_widget") as HTMLElement
            const pnf = document.getElementById("Page_0_Project_not_Found_widget") as HTMLElement
            ez.style.display = "none"
            pnf.style.display = "block"
            return
          }
          return rows
        })
        .catch(() => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[],[]);
          enterZipcloseLoader()
        })
    }
  }

  async function findSignSolar() {
__ea_trace("modules/entry/entry-form.ts","findSignSolar",[],[]);
    const select = document.getElementById("projectSelection") as HTMLSelectElement
    const selectedRowId = select.value
    const errorMsg = document.getElementById("selectError") as HTMLElement

    if (!selectedRowId || selectedRowId === "please select") {
      errorMsg.textContent = "Please select a Solar Farm"
      errorMsg.style.display = "block"
      return
    }

    errorMsg.textContent = ""
    errorMsg.style.display = "none"

    storage.rawSet("selectedSolarFarm", selectedRowId)

    try {
      // Single-row read: table id (15223639 == utilityFarm) + centralized portal
      // from __ENV__ (was a hardcoded id + rendering-portal "{{ hub_id }}").
      const response = await fetch(hubdbRowUrl("utilityFarm", selectedRowId))
      const row = await response.json()

      if (row?.values) {
        const values = row.values
        storage.rawSet("FarmStreetAddress1", values["3"] || "undefined")
        storage.rawSet("FarmStreetAddress2", values["13"] || "undefined")
        storage.rawSet("FarmCity", values["4"] || "undefined")
        storage.rawSet("FarmStateAbbreviation", values["5"] || "undefined")
        storage.rawSet("FarmName", values["7"] || "undefined")
        storage.rawSet("FarmID", values["1"] || "undefined")
        storage.rawSet("FarmPhoneNumber", values["23"] || "undefined")
        storage.rawSet("FarmLlcAddress1", values["24"] || "undefined")
        storage.rawSet("FarmLlcAddress2", values["25"] || "undefined")
        storage.rawSet("FarmLlcCity", values["26"] || "undefined")
        storage.rawSet("FarmLlcZip", values["27"] || "undefined")
        storage.rawSet("FarmEmail", values["28"] || "undefined")
        storage.rawSet("FarmProjectDescription", values["22"] || "undefined")
        storage.rawSet("FarmLlc", values["21"] || "undefined")
        storage.rawSet("FarmDisplayName", values["2"] || "undefined")
        storage.rawSet("FarmLMIDiscount", values["19"] || "undefined")
        storage.rawSet("FarmOpenDiscount", values["20"] || "undefined")

      } else {
        console.warn("⚠️ No row found with ID:", selectedRowId)
      }
    } catch (error) {
      console.error("❌ Error fetching row by ID:", error)
    }

    ;(document.getElementById("Page_0_Project_Found_widget") as HTMLElement).style.display = "block"
    ;(document.getElementById("Page_0_Enter_Zip_widget") as HTMLElement).style.display = "none"
  }

  /* ---- save utility create account url from session config --*/
  async function SaveUtilityCreateAccountUrlfromSession() {
__ea_trace("modules/entry/entry-form.ts","SaveUtilityCreateAccountUrlfromSession",[],[]);
    const exampleUtilityId = storage.rawGet("utility_id")
    const hubDBEndpointt = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: exampleUtilityId as string,
    })
    const responsee = await fetch(hubDBEndpointt, { method: "GET" })
    const dataa = await responsee.json()
    const rowss = dataa.objects
    if (rowss.length >= 1) {
      rowss.forEach((element: any) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          ;(document.querySelector("#addUtiDisName") as HTMLElement).textContent = element.values["5"]
          ;(document.querySelector("#utProvider") as HTMLAnchorElement).href = element.values["29"]
        }
      })
    }
  }

  /* Getting Address and Utility Name from Farm Table based on lowest priority */
  function checkUtilityIdInFarmTable(U_Id: string) {
__ea_trace("modules/entry/entry-form.ts","checkUtilityIdInFarmTable",[U_Id],["U_Id"]);
    const hubDBEndpoint = hubdbRowsUrl("utilityFarm", { utility_id: U_Id })
    fetch(hubDBEndpoint, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
        const rowss = data.objects
        const priorityArray: any[] = []
        let inc = 0
        for (let i = 0; i <= rowss.length; i++) {
          const currentobj = rowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          ++inc
          const FarmZip = currentobj.values[6]
          const FarmName = currentobj.values[7]
          const FarmID = currentobj.values[1]
          const priority = currentobj.values[12]
          const FarmDisplayName = currentobj.values[2]
          const FarmStreetAddress1 = currentobj.values[3]
          const FarmStreetAddress2 = currentobj.values[13]
          const FarmCity = currentobj.values[4]
          const FarmEmail = currentobj.values[28]
          const FarmPhoneNumber = currentobj.values[23]
          const FarmProjectDescription = currentobj.values[22]
          const FarmLlc = currentobj.values[21]
          const FarmLMIDiscount = currentobj.values[19]
          const FarmOpenDiscount = currentobj.values[20]
          const FarmCounty = currentobj.values[35]
          let FarmPayment = ""
          if (currentobj.values[36] !== undefined && currentobj.values[36] !== "undefined") {
            FarmPayment = currentobj.values[36].name
          }
          const myObject = {
            FarmZip,
            FarmName,
            FarmID,
            priority,
            FarmDisplayName,
            FarmStreetAddress1,
            FarmStreetAddress2,
            FarmCity,
            FarmEmail,
            FarmStateAbbreviation,
            FarmPhoneNumber,
            FarmProjectDescription,
            FarmLlc,
            FarmLMIDiscount,
            FarmOpenDiscount,
            FarmPayment,
            FarmCounty,
          }
          if (currentobj.values[9] === 1) {
            priorityArray.push(myObject)
          }
          if (i === rowss.length - 1) {
            if (priorityArray.length > 0) {
              const ezzz = document.getElementById("Page_0_Enter_Zip_widget") as HTMLElement
              const pnfff = document.getElementById("Page_0_Project_not_Found_widget") as HTMLElement
              const pfff = document.getElementById("Page_0_Project_Found_widget") as HTMLElement
              const pillfff = document.getElementById("Page_0_Illinois_Project_Found_widget") as HTMLElement
              ezzz.style.display = "none"
              pnfff.style.display = "none"
              window.scrollTo({ top: 0, behavior: "smooth" })
              if (FarmStateAbbreviation === "IL") {
                SaveUtilityCreateAccountUrlfromSession()
                pfff.style.display = "none"
                pillfff.style.display = "block"
              } else if (FarmStateAbbreviation === "MN" && U_Id === "XCEL-SF") {
                const url = hubdbRowsUrl("utilityAvailability", {
                  utility_id: "XCEL-SF",
                  project_selection: "YES",
                })
                fetch(url)
                  .then((response) => response.json())
                  .then((data) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[data],["data"]);
                    if (data.objects && data.objects.length > 0) {
                      pillfff.style.display = "none"
                      ezzz.style.display = "block"
                      const secondTableURL = hubdbRowsUrl("utilityFarm", {
                        utility_id: "XCEL-SF",
                        farm_enabled: "true",
                      })
                      fetch(secondTableURL)
                        .then((response) => response.json())
                        .then((datas) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[datas],["datas"]);
                          const select = document.getElementById("projectSelection") as HTMLSelectElement
                          if (datas.objects && datas.objects.length > 0) {
                            datas.objects.forEach((row: any) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[row],["row"]);
                              const values = row.values
                              const displayName = values["2"] || ""
                              const street = values["3"] || ""
                              const city = values["4"] || ""
                              const zip = values["6"] || ""
                              const rowid = row.id
                              const optionText = `${displayName} - ${street} ${city} ${zip}`
                              const option = document.createElement("option")
                              option.value = rowid
                              option.textContent = optionText
                              select.appendChild(option)

                              const findSolarElement = document.querySelector(".lfcsiya-find-solar") as HTMLElement
                              findSolarElement.style.display = "none"
                              const refCodeElement = document.querySelector(".refCodeWrapper") as HTMLElement
                              refCodeElement.style.display = "none"
                              ;(
                                document.querySelector(".lfcsiya-find-project-selection") as HTMLElement
                              ).style.display = "flex"
                              ;(document.querySelector(".zipCodeButton2") as HTMLElement).style.display = "block"
                              ;(document.querySelector(".zipCodeButton") as HTMLElement).style.display = "none"

                              const headingElement = document.querySelector(".lfcsiya-title") as HTMLElement
                              headingElement.innerHTML = ""
                              const h1Element = document.createElement("h2")
                              h1Element.textContent = "We have Solar in your area!"
                              headingElement.appendChild(h1Element)
                            })
                          }
                        })
                        .catch((error) => console.error("Error fetching solar farm rows:", error))
                    } else {
                      pillfff.style.display = "none"
                      pfff.style.display = "block"
                    }
                  })
                  .catch((err) => console.error("Error fetching filtered HubDB rows:", err))
              } else {
                pillfff.style.display = "none"
                pfff.style.display = "block"
              }
              const minPriorityObject = priorityArray.reduce(
                (min, obj) => (obj.priority < min.priority ? obj : min),
                priorityArray[0],
              )

              const addressAppend = document.querySelector("#Page_0_Project_Found_widget #addressAppend") as HTMLElement
              addressAppend.textContent =
                minPriorityObject.FarmStreetAddress1 +
                ", " +
                minPriorityObject.FarmCity +
                ", " +
                minPriorityObject.FarmStateAbbreviation
              storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
              storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
              storage.rawSet("FarmCity", minPriorityObject.FarmCity)
              storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
              storage.rawSet("FarmName", minPriorityObject.FarmName)
              storage.rawSet("FarmID", minPriorityObject.FarmID)
              storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
              storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
              storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
              storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
              storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
              storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
              storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
              storage.rawSet("FarmPayment", minPriorityObject.FarmPayment)
              storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)
              break
            } else {
              const ezz = document.getElementById("Page_0_Enter_Zip_widget") as HTMLElement
              const pnff = document.getElementById("Page_0_Project_not_Found_widget") as HTMLElement
              const pff = document.getElementById("Page_0_Project_Found_widget") as HTMLElement
              ezz.style.display = "none"
              pff.style.display = "none"
              window.scrollTo({ top: 0, behavior: "smooth" })
              pnff.style.display = "block"
              break
            }
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }

  // ─── user device info ─────────────────────────────────────────────────────────
  function getUserDeviceInfo() {
__ea_trace("modules/entry/entry-form.ts","getUserDeviceInfo",[],[]);
    const userAgent = navigator.userAgent
    let deviceName = "Unknown"
    let browserName = "Unknown"
    let browserVersion = "Unknown"
    let operatingSystem = "Unknown"

    if (/iPhone/i.test(userAgent)) {
      deviceName = "iPhone"
      operatingSystem = "iOS"
    } else if (/iPad/i.test(userAgent)) {
      deviceName = "iPad"
      operatingSystem = "iOS"
    } else if (/iPod/i.test(userAgent)) {
      deviceName = "iPod"
      operatingSystem = "iOS"
    } else if (/Android/i.test(userAgent)) {
      deviceName = "Mobile/Tablet"
      operatingSystem = "Android"
    } else if (/Windows Phone/i.test(userAgent)) {
      deviceName = "Windows Phone"
      operatingSystem = "Windows"
    } else if (/Macintosh|Mac OS/i.test(userAgent)) {
      deviceName = "Laptop/Desktop"
      operatingSystem = "MacOS"
    } else if (/Windows NT/i.test(userAgent)) {
      deviceName = "Laptop/Desktop"
      operatingSystem = "Windows"
    } else if (/Linux/i.test(userAgent)) {
      deviceName = "Laptop/Desktop"
      operatingSystem = "Linux"
    }

    if (/Edg./i.test(userAgent)) {
      browserName = "Microsoft Edge"
      browserVersion = (userAgent.match(/Edg\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    } else if (/Chrome/i.test(userAgent)) {
      browserName = "Google Chrome"
      browserVersion = (userAgent.match(/Chrome\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    } else if (/Firefox/i.test(userAgent)) {
      browserName = "Mozilla Firefox"
      browserVersion = (userAgent.match(/Firefox\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    } else if (/Safari/i.test(userAgent)) {
      browserName = "Apple Safari"
      browserVersion = (userAgent.match(/Version\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    } else if (/Opera|OPR/i.test(userAgent)) {
      browserName = "Opera"
      browserVersion = (userAgent.match(/(?:Opera|OPR)\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    } else if (/Trident/i.test(userAgent)) {
      browserName = "Internet Explorer"
      browserVersion = (userAgent.match(/Trident\/(\d+(\.\d+)?)/i) as RegExpMatchArray)[1]
    }

    return {
      device: deviceName,
      browser: browserName,
      browserVersion: browserVersion,
      operatingSystem: operatingSystem,
    }
  }

  const userInfo = getUserDeviceInfo()
  storage.rawSet("User Device", userInfo.device)
  storage.rawSet("Browser Name", `${userInfo.browser}, ${userInfo.browserVersion}`)
  storage.rawSet("Operating System", userInfo.operatingSystem)

  // ─── clear the LMI IndexedDB on entry ─────────────────────────────────────────
  const requestlmi = indexedDB.open("LmiDatabase", 1)
  let dblmi: IDBDatabase

  requestlmi.onerror = (event) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[event],["event"]);
    console.error(`LMI Database error: ${(event.target as IDBRequest).error}`)
  }
  requestlmi.onsuccess = (event) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[event],["event"]);
    dblmi = (event.target as IDBRequest).result
    clearDatabaselmi()
  }
  requestlmi.onupgradeneeded = (event) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[event],["event"]);
    const dblmi = (event.target as IDBRequest).result as IDBDatabase
    const objectStore = dblmi.createObjectStore("files", { autoIncrement: true })
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabaselmi() {
__ea_trace("modules/entry/entry-form.ts","clearDatabaselmi",[],[]);
    const transactionlmi = dblmi.transaction(Array.from(dblmi.objectStoreNames), "readwrite")
    transactionlmi.onerror = (event) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[event],["event"]);
      console.error("Error clearing database:", (event.target as IDBRequest).error)
    }
    Array.from(dblmi.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/entry/entry-form.ts","(anon)",[storeName],["storeName"]);
      const objectStorelmi = transactionlmi.objectStore(storeName)
      objectStorelmi.clear()
    })
  }

  // ─── wire the (formerly inline) handlers ──────────────────────────────────────
  zipCodeInput.addEventListener("input", () => validateNumericInput(zipCodeInput))
  root.querySelector(".zipCodeButton button")?.addEventListener("click", () => findSolar())
  root.querySelector(".zipCodeButton2 button")?.addEventListener("click", () => findSignSolar())
}
